// A simple templating method for replacing placeholders enclosed in curly braces.
if (!String.prototype.jsonFormat) {
    String.prototype.jsonFormat = function (o) {
        return this.replace(/{([^{}]*)}/g,
			function (a, b) {
			    var r = o[b];
			    return typeof r === 'string' || typeof r === 'number' ? r : a;
			});
    };
}

if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
            ? args[number]
            : match;
        });
    };
}

function getNotiUrl(https) {
    if (https) return "https://10.30.10.87:8089/signalR";
    else return "http://10.30.10.87:8088/signalR";
}

function getUrlVar() {
    var urlSlice = window.location.href.slice(window.location.href.indexOf("?") + 1)
    var urlSplit = urlSlice.split("&");
    var dic = {};
    for (var i = 0; i < urlSplit.length; i++) {
        var key = urlSplit[i].split("=")[0].toLowerCase();
        var value = urlSplit[i].split("=")[1];
        dic[key] = value;
    }
    return dic;
}

function selectTheme(theme) {

    if (theme === "1") {
        $('link[href*="Normal-Gray"]').attr('rel', '');
        $('link[href*="Sky-Blue"]').attr('rel', 'stylesheet');
        $('link[href*="Night-Gray"]').attr('rel', '');
    } else if (theme === "2") {
        $('link[href*="Normal-Gray"]').attr('rel', 'stylesheet');
        $('link[href*="Sky-Blue"]').attr('rel', '');
        $('link[href*="Night-Gray"]').attr('rel', '');
    } else if (theme === "99") {
        $('link[href*="Normal-Gray"]').attr('rel', '');
        $('link[href*="Sky-Blue"]').attr('rel', '');
        $('link[href*="Night-Gray"]').attr('rel', '');
    } else {

        $('link[href*="Normal-Gray"]').attr('rel', '');
        $('link[href*="Sky-Blue"]').attr('rel', '');
        $('link[href*="Night-Gray"]').attr('rel', 'stylesheet');
    }

}

function convertNumber2Currency(number, precision) {
    currency = parseFloat(number).toFixed(precision);
    currency = currency.toString().replace(/\B(?=(\d{3})+(?=\.))/g, ",");
    return currency;
}

function convertNumber2Thousand(number) {
    thousandNumber = parseInt(number);
    thousandNumber = thousandNumber.toString().replace(/\B(?=(\d{3})+$)/g, ",");
    return thousandNumber;
};

function changeContainerSize(elem) {
    var width = $(window).width();
    var height = $(window).height();
    $(elem).css('height', height);
    $(elem).css('width', width);
}

var customInputmask = (function () {
    var config = {
        extendDefaults: {
            showMaskOnHover: false,
            showMaskOnFocus: false
        },
        extendDefinitions: {},
        extendAliases: {
            'numeric': {
                radixPoint: '.',
                groupSeparator: ',',
                autoGroup: true,
                placeholder: '',
                min: 0,
                max: 9999999999
            },
            'decimal': {
                radixPoint: '.',
                groupSeparator: ',',
                autoGroup: true,
                placeholder: '',
                min: 0.001,
                max: 999999.999
            }
        }
    };

    var init = function () {
        Inputmask.extendDefaults(config.extendDefaults);
        Inputmask.extendDefinitions(config.extendDefinitions);
        Inputmask.extendAliases(config.extendAliases);
        $('[data-inputmask]').inputmask();
    };

    return {
        init: init
    };
}());